module.exports = __webpack_public_path__ + "assets/img/title-60a12b7d.png";